import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { RewardStatus, rewardStatusDictionary } from "Shared/types/Rewards";
import DPHeadCellWithTooltip from "Components/DP/DPHeadCell/DPHeadCell";
import { REWARD_STATUS_DESCRIPTIONS } from "./RewardStatusDescriptions";
import useStyles from "./styles";

export const RewardsStatusHeadCell = () => {
  const classes = useStyles();

  return (
    <DPHeadCellWithTooltip
      label="Status"
      width={500}
      content={
        <Grid container spacing={2}>
          {REWARD_STATUS_DESCRIPTIONS.map(({ status, description }) => (
            <Grid item key={status}>
              <Typography variant="h6" className={classes.text}>
                {rewardStatusDictionary[status as RewardStatus]}
              </Typography>
              <Typography variant="body1" className={classes.text}>
                {description}
              </Typography>
            </Grid>
          ))}
        </Grid>
      }
    />
  );
};
